import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { pathgen } from 'object-path-generator';
import { Box, TableList, Typography } from 'seagull';
import { DiscountType } from '~/types/api/billing/bulk/upload-csv';
import { utils } from '~/utils';
import styles from '../BulkInvoiceDetails.module.scss';
export const CustomerChargesTableTestIds = pathgen('CustomerChargesTableTestIds');
const chargesColumnDefs = [
    {
        width: 250,
        hAlign: 'start'
    },
    {
        width: 100,
        hAlign: 'end'
    },
    {
        width: 100,
        hAlign: 'end'
    },
    {
        width: 100,
        hAlign: 'end'
    },
    {
        width: 100,
        hAlign: 'end'
    }
];
const chargesHeaderItems = [
    {
        value: 'Service name'
    },
    {
        value: 'Quantity'
    },
    {
        value: 'Rate'
    },
    {
        value: 'Discount'
    },
    {
        value: 'Total'
    }
];
const getDiscountAmount = (discount)=>{
    if (!discount.amount) return '';
    if (discount.type === DiscountType.Percentage) return "".concat(utils.formatNumberWithCommas(discount.amount), "%");
    if (discount.type === DiscountType.Currency) return utils.formatDollarAmount(discount.amount);
    return '';
};
export const CustomerChargesTable = (param)=>{
    let { invoice, customerIndex } = param;
    const chargeItems = useMemo(()=>invoice.charges.map((charge, chargeIndex)=>({
                id: "".concat(customerIndex, "-charge-").concat(chargeIndex),
                cells: [
                    {
                        content: /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    ellipsis: true,
                                    variant: "paragraph1",
                                    testId: CustomerChargesTableTestIds.ChargeRow.ServiceName(customerIndex, chargeIndex),
                                    children: charge.serviceName
                                }),
                                charge.note && /*#__PURE__*/ _jsx(Typography, {
                                    ellipsis: true,
                                    variant: "paragraph3",
                                    skin: "secondary",
                                    testId: CustomerChargesTableTestIds.ChargeRow.Note(customerIndex, chargeIndex),
                                    children: charge.note
                                })
                            ]
                        })
                    },
                    {
                        content: charge.quantity,
                        testId: CustomerChargesTableTestIds.ChargeRow.Quantity(customerIndex, chargeIndex)
                    },
                    {
                        content: utils.formatDollarAmount(charge.rate),
                        testId: CustomerChargesTableTestIds.ChargeRow.Rate(customerIndex, chargeIndex)
                    },
                    {
                        content: getDiscountAmount(charge.discount),
                        testId: CustomerChargesTableTestIds.ChargeRow.Discount(customerIndex, chargeIndex)
                    },
                    {
                        content: utils.formatDollarAmount(charge.total),
                        testId: CustomerChargesTableTestIds.ChargeRow.Total(customerIndex, chargeIndex)
                    }
                ]
            })), [
        invoice
    ]);
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.chargesContainer,
        testId: CustomerChargesTableTestIds.Root(customerIndex),
        children: /*#__PURE__*/ _jsx(TableList.Provider, {
            columnDefs: chargesColumnDefs,
            children: /*#__PURE__*/ _jsx(TableList.Structure, {
                className: styles.visibleOverflow,
                header: /*#__PURE__*/ _jsx(TableList.Header, {
                    items: chargesHeaderItems
                }),
                content: /*#__PURE__*/ _jsx(_Fragment, {
                    children: chargeItems.map((item)=>/*#__PURE__*/ _jsx(TableList.Row, {
                            items: item.cells.map((cell)=>({
                                    value: cell.content,
                                    testId: cell.testId
                                }))
                        }, item.id))
                })
            })
        })
    });
};
